module.exports = __webpack_public_path__ + "img/Weapon_41.e83e3737.png";